// import React, { useEffect, useState } from "react";
// import Header from "../Pages/Header";
// import SideNavbar from "./SideNavbar";
// import { DatePicker, Spin, message } from "antd";
// import axios from "axios";
// import dayjs from "dayjs";

// import { toast } from "react-toastify";

// import { API_HEADER, get_project_task_RoleData, submit_timesheet } from "../config";
// import { useNavigate } from "react-router-dom";

// const { RangePicker } = DatePicker;

// const Timesheet = () => {
//     const navigate = useNavigate()
//   const [loading, setLoading] = useState(false);
//   const [totalTimeConsumed, setTotalTimeConsumed] = useState("0h 0m");
//   const [formData, setFormData] = useState({
//     project: "", 
//     task: "", 
//     role: "", 
//     startDate: null,
//     endDate: null,
//     status: "",
//     projects: [], 
//     tasks: [], 
//     roles: [], 
//   });

 

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         `${get_project_task_RoleData}`,
//         API_HEADER
//       );
//       console.log(response.data);
//       setFormData((prev) => ({
//         ...prev,
//         projects: response.data.projects,
//         roles: response.data.roles,
//         tasks: response.data.tasks,
//       }));
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       message.error("Failed to load data");
//     }
//   };
//   useEffect(() => {
//     fetchData();
//   }, []);


//   const statusOptions = [
//     "Work in progress",
//     "Complete",
//     "Allocated to other",
//     "Cancelled",
//   ];

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const calculateTimeDifference = (start, end) => {
//     if (!start || !end) return "0h 0m";

//     const diffInMs = end.valueOf() - start.valueOf();
//     const diffInHours = diffInMs / (1000 * 60 * 60);

//     const hours = Math.floor(diffInHours);
//     const minutes = Math.floor((diffInHours - hours) * 60);
//     return `${hours}h ${minutes}m`;
//   };

//   const handleDateChange = (dates) => {
//     if (dates && dates.length === 2) {
//       const [start, end] = dates;

//       // Validate end date is after start date
//       if (end.isBefore(start)) {
//         message.error("End date must be after start date");
//         return;
//       }

//       setFormData((prev) => ({
//         ...prev,
//         startDate: start,
//         endDate: end,
//       }));

//       // Calculate and set total time
//       setTotalTimeConsumed(calculateTimeDifference(start, end));
//     } else {
//       // Reset if dates are cleared
//       setFormData((prev) => ({
//         ...prev,
//         startDate: null,
//         endDate: null,
//       }));
//       setTotalTimeConsumed("0h 0m");
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       // Validate all required fields
//       if (
//         !formData.project ||
//         !formData.task ||
//         !formData.role ||
//         !formData.startDate ||
//         !formData.endDate ||
//         !formData.status
//       ) {
//         throw new Error("Please fill all required fields");
//       }

//       // Validate time range
//       if (formData.endDate.isBefore(formData.startDate)) {
//         throw new Error("End date must be after start date");
//       }

//       // Prepare payload
//       const payload = {
//         project_id: formData.project,
//         task_id: formData.task,
//         role_id: formData.role,
//         start_time: formData.startDate.toISOString(),
//         end_time: formData.endDate.toISOString(),
//         total_time: totalTimeConsumed,
//         status: formData.status,
//       };

//       // Make API call (replace with your actual endpoint)
//       const response = await axios.post(`${submit_timesheet}`, payload, API_HEADER);
//       console.log("response",response)

//      if(response.data.status){
//         toast.success("Timesheet Submitted Successfully");
//      }

//       setFormData({
//         project: "",
//         task: "",
//         role: "",
//         startDate: null,
//         endDate: null,
//         status: "",
//       });
//       setTotalTimeConsumed("0h 0m");
//       navigate('/dashboard')
//     } catch (error) {
//       console.error("Error submitting timesheet:", error);
//       toast.error("Failed to submit timesheet");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       <Header />
//       <SideNavbar />
//       <div className="content-wrapper bg-white">
//         <div className="content">
//           <div className="container-fluid bg-white">
//             <div className="row">
//               <div className="col-12">
//                 <h4 className="textcolorblue fw-bolder p-3 text-capitalize my-2 mx-4">
//                   Timesheet
//                 </h4>

//                 <Spin spinning={loading}>
//                   <form onSubmit={handleSubmit}>
//                     <div className="col-12 border-0 py-2 mx-auto">
//                       <div className="row">
//                         <div className="col-lg-4 col-md-4 col-12 mb-3">
//                           <label
//                             htmlFor="project"
//                             className="form-label lightgreen fs-6"
//                           >
//                             Projects<span style={{ color: "red" }}>*</span>
//                           </label>
//                           <select
//                             id="project"
//                             className="form-select borderlightgreen form-select-sm"
//                             name="project"
//                             required
//                             value={formData.project}
//                             onChange={handleChange}
//                           >
//                             <option value="">Select Project</option>
//                             {formData.projects.map((project) => (
//                               <option key={project.id} value={project.id}>
//                                 {project.project_name}
//                               </option>
//                             ))}
//                           </select>
//                         </div>
//                         <div className="col-lg-4 col-md-4 col-12 mb-3">
//                           <label
//                             htmlFor="task"
//                             className="form-label lightgreen fs-6"
//                           >
//                             Tasks<span style={{ color: "red" }}>*</span>
//                           </label>
//                           <select
//                             id="task"
//                             className="form-select borderlightgreen form-select-sm"
//                             name="task"
//                             required
//                             value={formData.task}
//                             onChange={handleChange}
//                           >
//                             <option value="">Select Task</option>
//                             {formData.tasks.map((task) => (
//                               <option key={task.id} value={task.id}>
//                                 {task.name}
//                               </option>
//                             ))}
//                           </select>
//                         </div>
//                         <div className="col-lg-4 col-md-4 col-12 mb-3">
//                           <label
//                             htmlFor="role"
//                             className="form-label lightgreen fs-6"
//                           >
//                             Role<span style={{ color: "red" }}>*</span>
//                           </label>
//                           <select
//                             id="role"
//                             className="form-select borderlightgreen form-select-sm"
//                             name="role"
//                             required
//                             value={formData.role}
//                             onChange={handleChange}
//                           >
//                             <option value="">Select Role</option>
//                             {formData.roles.map((role) => (
//                               <option key={role.id} value={role.id}>
//                                 {role.name}
//                               </option>
//                             ))}
//                           </select>
//                         </div>
//                       </div>

//                       <div className="row">
//                         <div className="col-lg-4 col-md-4 col-12 mb-3">
//                           <label className="form-label lightgreen fs-6">
//                             Date & Time Range
//                             <span style={{ color: "red" }}>*</span>
//                           </label>
//                           <RangePicker
//                             showTime={{ format: "HH:mm" }}
//                             format="YYYY-MM-DD HH:mm"
//                             onChange={handleDateChange}
//                             value={[formData.startDate, formData.endDate]}
//                             style={{ width: "100%" }}
//                           />
//                         </div>

//                         <div className="col-lg-4 col-md-4 col-12 mb-3">
//                           <label className="form-label lightgreen fs-6">
//                             Total Time Consumed
//                           </label>
//                           <div className="form-control-plaintext border rounded p-2 bg-light">
//                             {totalTimeConsumed}
//                           </div>
//                         </div>

//                         <div className="col-lg-4 col-md-4 col-12 mb-3">
//                           <label
//                             htmlFor="status"
//                             className="form-label lightgreen fs-6"
//                           >
//                             Status<span style={{ color: "red" }}>*</span>
//                           </label>
//                           <select
//                             id="status"
//                             className="form-select borderlightgreen form-select-sm"
//                             name="status"
//                             required
//                             value={formData.status}
//                             onChange={handleChange}
//                           >
//                             <option value="">Select Status</option>
//                             {statusOptions.map((status, index) => (
//                               <option key={index} value={status}>
//                                 {status}
//                               </option>
//                             ))}
//                           </select>
//                         </div>
//                       </div>

//                       <div className="row mt-4">
//                         <div className="col-12 text-center">
//                           <button
//                             type="submit"
//                             className="btn btn-success mt-5 px-4"
//                             disabled={loading}
//                           >
//                             {loading ? (
//                               <span>
//                                 <i className="fas fa-spinner fa-spin me-2"></i>
//                                 Submitting...
//                               </span>
//                             ) : (
//                               "Submit Timesheet"
//                             )}
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </form>
//                 </Spin>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Timesheet;




import React, { useEffect, useState } from "react";
import Header from "../Pages/Header";
import SideNavbar from "./SideNavbar";
import { DatePicker, Spin, message } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import Select from "react-select";
import { toast } from "react-toastify";
import { API_HEADER, get_project_task_RoleData, submit_timesheet } from "../config";
import { useNavigate } from "react-router-dom";

const { RangePicker } = DatePicker;

const Timesheet = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [totalTimeConsumed, setTotalTimeConsumed] = useState("0h 0m");
  const [formData, setFormData] = useState({
    project: null, // Changed to null for React Select
    task: "",
    role: "",
    startDate: null,
    endDate: null,
    status: "",
    projects: [], 
    tasks: [], 
    roles: [], 
  });

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${get_project_task_RoleData}`,
        API_HEADER
      );
      console.log(response.data);
      setFormData((prev) => ({
        ...prev,
        projects: response.data.projects,
        roles: response.data.roles,
        tasks: response.data.tasks,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Failed to load data");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const statusOptions = [
    "Work in progress",
    "Complete",
    "Allocated to other",
    "Cancelled",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // New handler for React Select
  const handleProjectChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      project: selectedOption,
    }));
  };

  const calculateTimeDifference = (start, end) => {
    if (!start || !end) return "0h 0m";

    const diffInMs = end.valueOf() - start.valueOf();
    const diffInHours = diffInMs / (1000 * 60 * 60);

    const hours = Math.floor(diffInHours);
    const minutes = Math.floor((diffInHours - hours) * 60);
    return `${hours}h ${minutes}m`;
  };

  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      const [start, end] = dates;

      if (end.isBefore(start)) {
        message.error("End date must be after start date");
        return;
      }

      setFormData((prev) => ({
        ...prev,
        startDate: start,
        endDate: end,
      }));

      setTotalTimeConsumed(calculateTimeDifference(start, end));
    } else {
      setFormData((prev) => ({
        ...prev,
        startDate: null,
        endDate: null,
      }));
      setTotalTimeConsumed("0h 0m");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (
        !formData.project ||
        !formData.task ||
        !formData.role ||
        !formData.startDate ||
        !formData.endDate ||
        !formData.status
      ) {
        throw new Error("Please fill all required fields");
      }

      if (formData.endDate.isBefore(formData.startDate)) {
        throw new Error("End date must be after start date");
      }

      const payload = {
        project_id: formData.project.value, // Access value from React Select
        task_id: formData.task,
        role_id: formData.role,
        start_time: formData.startDate.toISOString(),
        end_time: formData.endDate.toISOString(),
        total_time: totalTimeConsumed,
        status: formData.status,
      };

      const response = await axios.post(`${submit_timesheet}`, payload, API_HEADER);
      
      if(response.data.status){
        toast.success("Timesheet Submitted Successfully");
      }

      setFormData({
        project: null,
        task: "",
        role: "",
        startDate: null,
        endDate: null,
        status: "",
        projects: formData.projects,
        tasks: formData.tasks,
        roles: formData.roles,
      });
      setTotalTimeConsumed("0h 0m");
      navigate('/dashboard');
    } catch (error) {
      console.error("Error submitting timesheet:", error);
      toast.error(error.response?.data?.message || "Failed to submit timesheet");
    } finally {
      setLoading(false);
    }
  };

  // Format projects for React Select
  const projectOptions = formData.projects.map(project => ({
    value: project.id,
    label: `${project.project_name} / ${project.earthood_id}`,
  }));

  return (
    <div>
      <Header />
      <SideNavbar />
      <div className="content-wrapper bg-white">
        <div className="content">
          <div className="container-fluid bg-white">
            <div className="row">
              <div className="col-12">
                <h4 className="textcolorblue fw-bolder p-3 text-capitalize my-2 mx-4">
                  Timesheet
                </h4>

                <Spin spinning={loading}>
                  <form onSubmit={handleSubmit}>
                    <div className="col-12 border-0 py-2 mx-auto">
                      <div className="row">
                        <div className="col-lg-4 col-md-4 col-12 mb-3">
                          <label
                            htmlFor="project"
                            className="form-label lightgreen fs-6"
                          >
                            Projects<span style={{ color: "red" }}>*</span>
                          </label>
                          <Select
                            id="project"
                            name="project"
                            options={projectOptions}
                            value={formData.project}
                            onChange={handleProjectChange}
                            placeholder="Select Project"
                            isSearchable
                            required
                            isClearable
                            // styles={{
                            //   control: (base) => ({
                            //     ...base,
                            //     minHeight: '32px',
                            //     height: '32px',
                            //   }),
                            //   dropdownIndicator: (base) => ({
                            //     ...base,
                            //     padding: '4px',
                            //   }),
                            //   clearIndicator: (base) => ({
                            //     ...base,
                            //     padding: '4px',
                            //   }),
                            //   valueContainer: (base) => ({
                            //     ...base,
                            //     padding: '0px 8px',
                            //   }),
                            //   input: (base) => ({
                            //     ...base,
                            //     margin: '0px',
                            //   }),
                            // }}
                          />
                        </div>
                        <div className="col-lg-4 col-md-4 col-12 mb-3">
                          <label
                            htmlFor="task"
                            className="form-label lightgreen fs-6"
                          >
                            Tasks<span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            id="task"
                            className="form-select borderlightgreen form-select-sm"
                            name="task"
                            required
                            value={formData.task}
                            onChange={handleChange}
                          >
                            <option value="">Select Task</option>
                            {formData.tasks.map((task) => (
                              <option key={task.id} value={task.id}>
                                {task.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-4 col-md-4 col-12 mb-3">
                          <label
                            htmlFor="role"
                            className="form-label lightgreen fs-6"
                          >
                            Role<span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            id="role"
                            className="form-select borderlightgreen form-select-sm"
                            name="role"
                            required
                            value={formData.role}
                            onChange={handleChange}
                          >
                            <option value="">Select Role</option>
                            {formData.roles.map((role) => (
                              <option key={role.id} value={role.id}>
                                {role.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-4 col-md-4 col-12 mb-3">
                          <label className="form-label lightgreen fs-6">
                            Date & Time Range
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <RangePicker
                            showTime={{ format: "HH:mm" }}
                            format="YYYY-MM-DD HH:mm"
                            onChange={handleDateChange}
                            value={[formData.startDate, formData.endDate]}
                            style={{ width: "100%" }}
                          />
                        </div>

                        <div className="col-lg-4 col-md-4 col-12 mb-3">
                          <label className="form-label lightgreen fs-6">
                            Total Time Consumed
                          </label>
                          <div className="form-control-plaintext border rounded p-2 bg-light">
                            {totalTimeConsumed}
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-4 col-12 mb-3">
                          <label
                            htmlFor="status"
                            className="form-label lightgreen fs-6"
                          >
                            Status<span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            id="status"
                            className="form-select borderlightgreen form-select-sm"
                            name="status"
                            required
                            value={formData.status}
                            onChange={handleChange}
                          >
                            <option value="">Select Status</option>
                            {statusOptions.map((status, index) => (
                              <option key={index} value={status}>
                                {status}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="row mt-4">
                        <div className="col-12 text-center">
                          <button
                            type="submit"
                            className="btn btn-success mt-5 px-4"
                            disabled={loading}
                          >
                            {loading ? (
                              <span>
                                <i className="fas fa-spinner fa-spin me-2"></i>
                                Submitting...
                              </span>
                            ) : (
                              "Submit Timesheet"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timesheet;